"use strict";

var JobEvent = Backbone.Model.extend({

    initialize: function(attributes, options) {
        this.urlRoot = Core.contextRoot + '/job/' + options.jobId + '/event'
    }
});

var Job = Core.ShareableModel.extend({
	urlRoot: Core.contextRoot + '/job',
    editGroupPermission: 'admin_jobs',

    initialize: function(attributes, options) {
        if (options && options.urlRoot) this.urlRoot = options.urlRoot;
    },

    defaults: function() {
        return {
            uuid: Core.randomUUID(),
            state: 'PUBLISHED',
            documents: [],
            labels: [],
            stateTracked: true,
            toBeReported: true,
            toBeInvoiced: true,
        };
    },

    emptyTemplate: function() {
        return {
            description: '',
            workItems: [],
            destinations: [],
            items: [],
            forms: [],
            documents: [],
            resources: [],
            excludedFields: [],
            customFields: [],
            internalFields: [],
            requiredFields: []
        }
    },

    setFromTemplate: function (template, previousTemplate) {
        //console.log('Job.setFromTemplate', template ? template.get('title') : 'NONE', template.attributes);
        // similar to domain: Job.copyFromTemplate() and client: JobCache.createJobFromTemplate()
        var attributes = $.extend(true, {}, template.attributes);
        attributes.fromTemplateId = template.attributes.id;
        delete attributes.title;
        delete attributes.id;
        delete attributes.uuid;
        delete attributes.version;
        delete attributes.lastModified;
        delete attributes.creatorId;
        delete attributes.creationTimeStamp;
        //delete attributes.resources;
        delete attributes.state;
        delete attributes.finalState;
        delete attributes.jobNo;
        delete attributes.template;
        delete attributes.discrepancy;
        //delete attributes.unconfirmedDiscrepancy;
        delete attributes.startedTimeStamp;
        delete attributes.endedTimeStamp;
        delete attributes.events;
        delete attributes.invoiceId;
        delete attributes.invoicedTimeStamp;
        delete attributes.invoicedById;
        delete attributes.totalPrice;
        delete attributes.totalPriceComplete;
        delete attributes.totalInvoicedPrice;
        delete attributes.totalInvoicedCost;
        delete attributes.pendingInvoicingPrice;
        delete attributes.pendingInvoicingPriceComplete;
        delete attributes.contractInfo;
        delete attributes.attestedByFullName;
        delete attributes.attestedById;
        delete attributes.attestedTimeStamp;
        delete attributes.remoteSignature;
        delete attributes.transportDocuments;

        if (attributes.workItems)
            _(attributes.workItems).each(function (workItem) {
                delete workItem.id;
                delete workItem.done;
                delete workItem.doneByUserId;
                delete workItem.doneTimeStamp;
            });
        if (attributes.destinations) {
            _(attributes.destinations).each(function (destination) {
                if (destination.workItems)
                    _(destination.workItems).each(function (workItem) {
                        delete workItem.id;
                        delete workItem.done;
                        delete workItem.doneByUserId;
                        delete workItem.doneTimeStamp;
                    });
                delete destination.id;
            });
        }
        if (attributes.resources)
            _(attributes.resources).each(function (resource) {
                delete resource.id;
                delete resource.uuid;
                if (resource.state != 'ASSIGNED' && resource.state != 'UNASSIGNED') resource.state = 'SCHEDULED';
            });
        if (attributes.items)
            _(attributes.items).each(function (item) {
                delete item.id;
                delete item.uuid;
                delete item.invoiceId;
                delete item.invoicedTimeStamp;
                delete item.deliveryDate;
                delete item.deliveredById;
                delete item.delivered;
            });
        if (attributes.documents)
            _(attributes.documents).each(function (document) { delete document.id; delete document.uuid; });
        if (attributes.forms)
            _(attributes.forms).each(function (form) { delete form.formId; delete form.formUuid; delete form.formState; });
        if (attributes.bookingRequests && attributes.bookingRequests.length > 0) {
            _(attributes.bookingRequests).each(function (request) {
                delete request.id;
                delete request.uuid;
            });
        }
        // Retain values from previous template
        var current = this.attributes;
        var previous = previousTemplate ? previousTemplate.attributes : this.emptyTemplate();

        if (current.startTime != previous.startTime) delete attributes.startTime;
        if (current.endTime != previous.endTime) delete attributes.endTime;
        if (current.duration != previous.duration) delete attributes.duration;
        if (current.customerId != previous.customerId) delete attributes.customerId;
        if (current.customerProjectId != previous.customerProjectId) delete attributes.customerProjectId;
        if (current.assetId != previous.assetId) delete attributes.assetId;
        if (current.activityId != previous.activityId) delete attributes.activityId;

        // Don't change group if we don't have permission in that group
        if (!Core.client.hasGroupPermission(attributes.groupId, 'create_jobs')) delete attributes.groupId;
        // Retain current group if template is from parent group
        if (template.isValidForGroup(current.groupId)) delete attributes.groupId;

        var contact = current.contact;
        var prevContact = previous.contact;
        if (contact && prevContact) {
            if (contact.name != prevContact.name || contact.emailAddress != prevContact.emailAddress || contact.phoneNo != prevContact.phoneNo)
                delete attributes.contact;
        } else if (contact != prevContact)
            delete attributes.contact;

        if (previousTemplate && current.description != previous.description) delete attributes.description;
        if (attributes.customFields && current.customFields) {
            _(current.customFields).each(function (prefield) {
                var postfield = _(attributes.customFields).findWhere({name: prefield.name});
                if (!postfield && prefield.label) postfield = _(attributes.customFields).findWhere({label: prefield.label});
                if (postfield) {
                    var prevField = previous.customFields
                        ? (_(previous.customFields).findWhere({name: prefield.name}) || (prefield.label ? _(previous.customFields).findWhere({label: prefield.label}) : null))
                        : null;
                    if (prevField && prefield.value != prevField.value) postfield.value = prefield.value;
                }
            }, this);
        }

        if (current.workItems && current.workItems.length > 0 && (!attributes.workItems || attributes.workItems.length == 0) && (!previous.workItems || previous.workItems.length == 0))
            attributes.workItems = current.workItems;

        if (current.destinations && current.destinations.length > 0 && previous.destinations && previous.destinations.length > 0) {
            var keepDestinations = false;
            for (var i = 0; i < current.destinations.length; i++) {
                if (i >= previous.destinations.length) {
                    keepDestinations = true;
                    break;
                }
                if (current.destinations[i].location && previous.destinations[i].location) {
                    if (current.destinations[i].location.placeName != previous.destinations[i].location.placeName) {
                        keepDestinations = true;
                        break;
                    }
                }
            }

            if (keepDestinations) {
                while (attributes.destinations && attributes.destinations.length > current.destinations.length) {
                    current.destinations.push({});
                }
                if (attributes.destinations && attributes.destinations.length < current.destinations.length) {
                    current.destinations.splice(attributes.destinations.length, current.destinations.length);
                }
                attributes.destinations = current.destinations;
            }
        } else if (current.destinations && current.destinations.length > 0)
            attributes.destinations = current.destinations;
            
        if (current.items && current.items.length > 0 && (!attributes.items || attributes.items.length == 0) && (!previous.items || previous.items.length == 0))
            attributes.items = current.items;
        if (current.documents && current.documents.length > 0 && (!attributes.documents || attributes.documents.length == 0) && (!previous.documents || previous.documents.length == 0))
            attributes.documents = current.documents;

        this.set(attributes);
    },

    // getters

	isDispatchable: function() {
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        if (this.get('routeId')) return false;
        if (this.get('state') == 'CLOSED') return false;
        if (this.get('attestedTimeStamp')) return false;
		if (this.get('groupId'))
			return Core.client.hasGroupPermission(this.get('groupId'), 'dispatch');
		else
			return this.isEditable();
	},

	isPublished: function() {
		var state = this.get('state');
		return (state && state != 'ORDER' && state != 'DRAFT' && state != 'CLOSED' && !this.get('attestedTimeStamp'));
	},

	isPublishedOrDraft: function() {
		var state = this.get('state');
		return (state && state != 'ORDER' && state != 'CLOSED' && !this.get('attestedTimeStamp'));
	},

	isActive: function() {
		var state = this.get('state');
		return (state == 'IN_TRANSIT' || state == 'ON_STATION' || state == 'STARTED' || state == 'PAUSED');
	},

    isToBeInvoiced: function() {
        if (this.get('customerId')) {
            var customer = Core.client.customers.get(this.get('customerId'));
            if (!customer)
                return true;
            if (!customer.get('invoiced'))
                return false;
            if (this.get('customerProjectId')) {
                var customerProject = customer.getCustomerProjectById(this.get('customerProjectId'));
                if (customerProject && !customerProject.invoiced)
                    return false;
            }
            return true;
        }
        return true;
    },

    isAttestable: function() {
        if (!Core.client.hasPermission('attest')) return false;
        if (this.invoiced) return false;
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        if (this.get('attestedTimeStamp')) return false;
        if (!this.isAttestableByContract()) return false;
        var group = Core.client.groups.get(this.get('groupId'));
        if (group && group.get('features') && group.get('features').indexOf('attest') < 0) return false;
        if (Core.client.hasGroupPermission(this.get('groupId'), 'attest_jobs')) return true;
    },

    isAttestableByContract: function() {
        var resourceWithContract = _(this.get('resources')).find(function(res) { return res.contractId});
        if (Core.client.contracts && Core.client.contracts.length > 0) {
            if (this.get('contractInfo')) {
                var contract = Core.client.contracts.get(this.get('contractInfo').contractId);
                if (contract != null) {
                    switch (contract.get('attestMode')) {
                        case 'CUSTOMER':
                        case 'CUSTOMER_FORCE':
                            return false;
                    }
                }
            } else if (resourceWithContract) {
                var allResourcesContracted = true;
                _(this.get('resources')).each(function (res) {
                    if (!res.contractId) allResourcesContracted = false;
                })
                if (allResourcesContracted) {
                    var contract = Core.client.contracts.get(resourceWithContract.contractId);
                    if (contract != null) {
                        switch (contract.get('attestMode')) {
                            case 'SUPPLIER':
                                return false;
                        }
                    }
                }
            }
        }
        return true;
    },

    isPublishable: function() {
        if (!Core.client.me.id) return false;
        if (this.get('deleted')) return false;
        if (this.get('attestedTimeStamp') && Core.client.hasGroupPermission(this.get('groupId'), 'attest_jobs') && this.isAttestableByContract()) return true;
        if (this.get('invoicedTimeStamp') && Core.client.hasGroupPermission(this.get('groupId'), 'invoicing') && this.get('state') == 'DRAFT') return true;
    },

	routeId: function() {
		return this.get('destinations') && this.get('destinations')[0] && this.get('destinations')[0].routeId;
	},

	isLate: function() {
		var state = this.get('state');
        var startTime = this.get('startTime');
        var endTime = this.get('endTime');
        var allDay = this.get('allDay');
        var stateTracked = this.get('stateTracked');
        var duration = this.get('duration');
		if (state == 'INITIAL' || state == 'DRAFT' || state == 'FINISHED' || state == 'CANCELED' || state == 'CLOSED')
			return false;
		if (endTime && new Date().getTime() > endTime + (allDay ? 24*3600000 : 0))
			return true;
        if (!allDay && !endTime && startTime && duration && new Date().getTime() > startTime + duration*60000)
            return true;
        if (stateTracked && (state == 'IN_TRANSIT' || state == 'ON_STATION' || state == 'STARTED' || state == 'PAUSED' || state == 'DAY_FINISHED'))
            return false;
        if (stateTracked && startTime && new Date().getTime() > startTime + (allDay ? 24*3600000 : 0))
            return true;
		return false;
	},

	isResourceScheduled: function(resource) {
		var state = resource.state;
		return (resource.userId || resource.external) && state != 'UNASSIGNED' && state != 'ASSIGNED' && state != 'DECLINED';
	},

	isResourceLate: function(resource) {
        if (!resource) return undefined;
		var state = resource.state;
        var startTime = this.get('startTime');
        var endTime = this.get('endTime');
        var allDay = this.get('allDay');
        var stateTracked = this.get('stateTracked');
        var duration = this.get('duration');
		if (state == 'FINISHED' || state == 'CANCELED' || state == 'DECLINED')
			return false;
        if (endTime != null && new Date().getTime() > endTime + (allDay ? 24*3600000 : 0))
            return true;
        if (!allDay && !endTime && startTime && duration && new Date().getTime() > startTime + duration*60000)
            return true;
        if (stateTracked && (state == 'IN_TRANSIT' || state == 'ON_STATION' || state == 'STARTED' || state == 'PAUSED' || state == 'DAY_FINISHED'))
            return false;
        if (stateTracked && startTime && new Date().getTime() > startTime + (allDay ? 24*3600000 : 0))
            return true;
		return false;
	},

	getResourceId: function(resourceId) {
		return _(this.get('resources')).find(function (resource) { return resource.id == resourceId; });
	},

	getResource: function(userOrContractId) {
		return _(this.get('resources')).find(function (resource) { return resource.userId == userOrContractId || (resource.contractId && resource.contractId == userOrContractId); });
	},

    getResourceByVehicle: function(vehicleId) {
        return _(this.get('resources')).find(function (resource) { return resource.vehicleId == vehicleId; });
    },

	myResource: function() {
		return Core.client && Core.client.me && this.getResource(Core.client.me.id);
	},

    myScheduledResource: function() {
        var resource = this.myResource();
        return resource && resource.state != 'ASSIGNED' && resource.state != 'DECLINED';
    },

	getNotes: function() {
		if (!this.attributes.events)
			return [];
		var notes = [];
		for (var i = 0; i < this.attributes.events.length; i++) {
			var event = this.attributes.events[i];
			if (event.type == 'NOTE')
				notes.push(event);
		}
		return notes;
	},

	isWorkItemDone: function(id) {
		for (var i = 0; i < this.attributes.workItems.length; i++) {
			var item = this.attributes.workItems[i];
			if (item.id == id)
				return item.done;
		}
		for (var d = 0; d < this.attributes.destinations.length; d++) {
			var destination = this.attributes.destinations[d];
			for (var i = 0; i < destination.workItems.length; i++) {
				var item = destination.workItems[i];
				if (item.id == id)
					return item.done;
			}

		}
	},

	canScheduleMe: function() {
		if (Core.client.me.id && !this.myResource() && this.get('state') != 'CLOSED' && (this.get('selfScheduled') || Core.client.hasGroupPermission(this.get('groupId'), 'schedule_self') || this.get('creatorId') == Core.client.me.id)) {
			if (this.get('groupId') && !Core.client.hasGroupPermission(this.get('groupId'), 'do_work'))
				return false;
			if (this.getFreeResource() || (this.get('autoAddResources') && !this.myScheduledResource() && Core.client.hasGroupPermission(this.get('groupId'), 'schedule_self')))
				return true;
		}
		return false;
	},

	canScheduleOthers: function() {
        return this.isDispatchable() && this.get('state') != 'CLOSED' && this.getFreeResource();
	},

    canAddResource: function() {
        var forbiddenByContract = false;
        if (this.get('contractInfo')) {
            var contract = Core.client.contracts.get(this.get('contractInfo').contractId);
            if (contract && contract.get('jobSupplierFields').indexOf('resources') < 0) forbiddenByContract = true;
        }

        return !this.get('routeId') && this.get('state') != 'CLOSED' && (this.isDispatchable() || (this.myScheduledResource() && this.get('selfScheduled') && Core.client.hasGroupPermission(this.get('groupId'), 'view_other_users'))) && !forbiddenByContract;
    },

	getFreeResource: function() {
        if (this.get('routeId')) return null;
        var freeResource = _(this.get('resources')).find(function (resource) { return (!resource.userId && !resource.external) || resource.state == 'DECLINED'; });
        if (!freeResource && (!this.get('resources') || this.get('resources').length == 0)) return {};
        return freeResource;
	},

    getDestination: function(destinationId) {
        return _(this.get('destinations')).find(function (destination) { return destination.id == destinationId; });
    },

    hasContract: function() {
        return this.hasContractCustomer() || this.hasContractSupplier();
    },

    hasContractCustomer: function() {
        return this.get('contractInfo');
    },

    hasContractSupplier: function() {
        return _(this.get('resources')).find(function (resource) { return resource.contractId; });
    },

    // actions

	accept: function() {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/accept',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
	},

	decline: function() {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/decline',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
	},

	close: function() {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/close',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
	},

    attest: function() {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/attest',
            type: 'PUT'
        }).success(function (data) {
            self.set(data);
        });
    },

	publish: function() {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/publish',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
	},

	unpublish: function() {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/unpublish',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
	},

    bookingRequest: function(){
        var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/bookingRequest',
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
    },

	unschedule: function(userId, sendMessage, resourceId) {
		var self = this;
		var params = { userId: userId };
		if (sendMessage)
			params.sendMessage = true;
        if (resourceId)
            params.resourceId = resourceId;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/unschedule?' + $.param(params),
			type: 'PUT'
		}).success(function (data) {
			self.set(data, {silent: true});
		});
    },
    
    unscheduleResource: function(resourceId) {
        var self = this;
        var params = {resourceId:resourceId}
        return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/unschedule?' + $.param(params),
			type: 'PUT'
		}).success(function (data) {
			self.set(data, {silent: true});
		});
    },

	schedule: function(userId, sendMessage, sendEmail, sendSMS) {
        var self = this;
        if (userId === 'external') {
            console.error("Can't schedule an external resource like it's a user")
            return null;
        }
        var user = Core.client.users.get(userId);
		var params = { userId: userId };
        if (sendMessage) params.sendMessage = true;
        if (sendEmail) params.sendEmail = 'true';
        if (sendSMS) params.sendSMS = 'true';
        if (user && user.get('inVehicleId')) params.vehicleId = user.get('inVehicleId');
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/schedule?' + $.param(params),
			type: 'PUT'
		}).success(function (data) {
			self.set(data, {silent: true});
		});
	},

    bulkSchedule: function(data) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/schedule/bulk',
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(data)
        }).success(function(data) {
            self.set(data, { silent: true });
        });
    },

	assign: function(userId, sendMessage) {
		var self = this;
        var params = { userId: userId };
        if (userId === 'external') {
            console.error("Can't schedule an external resource like it's a user")
            return null;
        }
        var user = Core.client.users.get(userId);
        if (sendMessage) params.sendMessage = true;
        if (user.get('inVehicleId')) params.vehicleId = user.get('inVehicleId');
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/assign?' + $.param(params),
			type: 'PUT'
		}).success(function (data) {
			self.set(data, {silent: true});
		});
    },

	changeResource: function(newUserId, sendMessage, acceptDecline) {
		var self = this;
		if (newUserId === 'external') {
			console.error("Can't schedule an external resource like it's a user")
			return null;
		}
		if (this.get('resources').filter(function(resource) { return resource.userId != null || resource.userId != undefined }).length > 1)
			return false;
		// Since only one userId should exist here, find() should do fine here
		var oldUserId = this.get('resources').find(function(resource) { return resource.userId ? resource.userId : false }).userId;

		var params = { userId: newUserId };
		if (sendMessage) params.sendMessage = true;
		return $.ajax({
			url: this.urlRoot + '/' + this.get('uuid') + '/unschedule?' + $.param(params),
			type: 'PUT'
		}).success(function(data) {
			params.userId = oldUserId;
			return $.ajax({
				url: self.urlRoot + '/' + self.get('uuid') + (acceptDecline ? '/assign?' : '/schedule?') + $.param(params),
				type: 'PUT'
			}).success(function(data) {
				self.set(data, { silent: true })
			})
		})
	},
    
    scheduleExternal: function(fullName, emailAddress, phoneNo, resourceId, sendEmail, sendSMS) {
        var self = this;
        var externalResource = {
            "fullName":fullName,
            "emailAddress": emailAddress,
            "phoneNo": phoneNo
        }
        var params = {}
        if (resourceId) {
            params.resourceId = resourceId;
        }
        if(sendEmail) {
            params.email = 'true'
        }
        if(sendSMS) {
            params.sms = 'true'
        }
        return $.ajax({
            url: this.urlRoot+'/'+this.get('uuid')+'/schedule/external?' + $.param(params),
            type: 'PUT',
            data: JSON.stringify(externalResource),
            headers: { "Content-Type": "application/json"}
        }).success(function (data) {
            self.set(data, {silent: true});
        })
    },

    scheduleVehicle: function(vehicleId, resource) {
        var self = this;
        var params = { vehicleId: vehicleId };
        if (resource && resource.userId) params.userId = resource.userId;
        if (resource && resource.external) params.external = resource.external;
        if (resource && resource.id) params.resourceId = resource.id;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/schedule?' + $.param(params),
            type: 'PUT'
        }).success(function (data) {
            self.set(data, {silent: true});
        });
    },

    unscheduleVehicle: function(vehicleId, resource) {
        var self = this;
        var params = { vehicleId: vehicleId };
        if (resource && resource.userId) params.userId = resource.userId;
        if (resource && resource.external) params.external = resource.external;
        if (resource && resource.id) params.resourceId = resource.id;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/unschedule?' + $.param(params) ,
            type: 'PUT'
        }).success(function (data) {
            self.set(data, {silent: true});
        });
    },

    assignResourceAsset: function(resourceId, assetId) {
	    var self = this;
	    return $.ajax({
	        url: this.urlRoot + '/' + this.get('uuid') + '/resource/' + resourceId + '/asset/' + assetId,
            type: 'PUT'
        }).success(function (data) {
            if (data) self.set(data, {silent: true});
        });
    },

    unassignResourceAsset: function(resourceId, assetId) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/resource/' + resourceId + '/asset/' + assetId,
            type: 'DELETE'
        }).success(function (data) {
            if (data) self.set(data, {silent: true});
        });
    },

    assignResourceContract: function(resourceId, contractId) {
	    var self = this;
	    return $.ajax({
	        url: this.urlRoot + '/' + this.get('uuid') + '/resource/' + resourceId + '/contract/' + contractId,
            type: 'PUT'
        }).success(function (data) {
            if (data) self.set(data, {silent: true});
        });
    },

    addResourceAssetType: function(resourceId, assetTypeId) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/resource/' + resourceId + '/asset/type/' + assetTypeId,
            type: 'POST'
        }).success(function (data) {
            if (data) self.set(data, {silent: true});
        });
    },

    deleteResourceAssetType: function(resourceId, assetTypeId) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/resource/' + resourceId + '/asset/type/' + assetTypeId,
            type: 'DELETE'
        }).success(function (data) {
            if (data) self.set(data, {silent: true});
        });
    },

    addResource: function() {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/resource',
            type: 'POST'
        }).success(function (data) {
            self.set(data, {silent: true});
        });
    },

    deleteResource: function(resourceId) {
        if (typeof resourceId == 'object') resourceId = resourceId.id;
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/resource/' + resourceId,
            type: 'DELETE'
        }).success(function (data) {
            self.set(data, {silent: true});
        });
    },

    overrideState: function(state, includeResources) {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.id + '/state/' + state + (includeResources ? '?resources' : ''),
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
	},

	reportUserState: function(userId, state) {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.id + '/user/' + userId + '/state/' + state,
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
    },
    
    reportExternalResourceState: function(resourceId, state) {
		var self = this;
		return $.ajax({
			url: this.urlRoot + '/' + this.id + '/resource/' + resourceId + '/state/' + state,
			type: 'PUT'
		}).success(function (data) {
			self.set(data);
		});
    },
    
	reportWorkItemDone: function(workItem, done) {
		if (typeof done == 'undefined')
			done = true;
		workItem.done = done;
		workItem.doneByUserId = Core.client.me.id;
		workItem.doneTimeStamp = new Date().getTime();
		return $.ajax({
			url: this.urlRoot + '/' + this.id + '/workitem/' + workItem.id,
			type: 'PUT',
			data: { done: done }
		});
	},

    follow: function(follower) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/follower/me',
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(follower),
        }).success(function (data) {
            self.set(data, {silent: true});
        });
    },

    unfollow: function() {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.get('uuid') + '/follower/me',
            type: 'DELETE'
        }).success(function (data) {
            self.set(data, {silent: true});
        });
    },

    geocode: function() {
        if (this.get('destinations')) {
            // Geocode the FIRST NON-GEOCODED address (and return the xhr object)
            for (var i = 0; i < this.get('destinations').length; i++) {
                var destination = this.get('destinations')[i];
                if (!destination.location) destination.location = {};
                if (!destination.pendingGeocode && (destination.geocodeResult == 'fail' || (destination.location.latitude && destination.location.longitude))) continue;
                if (!destination.location.placeName) continue;
                if (destination.location.placeName.indexOf('<') == 0) continue; // special case for having a label like "<<< pick a place"
                if (destination.isGeocoding) continue;
                destination.isGeocoding = true;
                this.trigger('geocodestart');
                console.log('geocode', destination.location.placeName);
                var self = this;
                return $.getJSON(Core.contextRoot + '/map/search?' + $.param({q: destination.location.placeName}), function (response) {
                    if (response.places && response.places.length >= 1) {
                        var place = response.places[0];
                        console.log(destination.location.placeName + ' => \n' + place.name + ' ' + place.latitude + ' ' + place.longitude + ' - ' + place.type + ' ' + place.source);
                        destination.location.latitude = place.latitude;
                        destination.location.longitude = place.longitude;
                        destination.geocodedPlace = place;
                        if (place.type == 'STREET_ADDRESS' || place.type == 'PLACE')
                            destination.geocodeResult = 'ok';
                        else
                            destination.geocodeResult = 'warn';
                    } else {
                        console.log('geocoding failed', response, destination.location.placeName);
                        delete destination.geocodedPlace;
                        destination.geocodeResult = 'fail';
                    }
                    self.geocodeResult = destination.geocodeResult;
                    delete destination.isGeocoding;
                    delete destination.pendingGeocode;
                    delete destination.geocodedReverse;
                    self.trigger('geocodedone');
                });
            }
        }
    },

    reverseGeocodeDestination: function(destination) {
        var params = $.param({lat: destination.location.latitude, lon: destination.location.longitude});
        return $.getJSON(Core.contextRoot + '/map/search?' + params, function (result) {
            if (result.places) {
                var address = result.places[0].name;
                address = address.replace(', ' + result.places[0].country, '');
                destination.location.placeName = address;
                destination.geocodedPlace = result.places[0];
            }
            destination.geocodedReverse = true;
            destination.pendingGeocode = false;
        });
    },

    route: function(routeTemplate) {
        if (this.get('destinations')) {
            // Route the FIRST NON-ROUTED address (and return the xhr object)
            for (var i = 1; i < this.get('destinations').length; i++) {
                var destination = this.get('destinations')[i];
                if (destination.routeData || destination.routed) continue;
                if (!destination.location || !destination.location.latitude || !destination.location.longitude) {
                    i++;
                    continue;
                }
                return this.routeDestination(destination, routeTemplate);
            }
        }
    },

    routeDestination: function(toDestination, routeTemplate) {
        if (typeof toDestination == 'number')
            toDestination = this.get('destinations')[toDestination];
        if (!toDestination) {
            console.error('Cannot route destination - toDestination is null!');
            return null;
        }
        var fromDestination = this.get('destinations')[this.get('destinations').indexOf(toDestination)-1];
        if (!fromDestination) {
            console.error('Cannot route destination - fromDestination is null!');
            return null;
        }
        var params = {};
        if (routeTemplate) {
            if (routeTemplate.get('modeOfTransport'))
                params.transport = routeTemplate.get('modeOfTransport');
            if (routeTemplate.get('type'))
                params.type = routeTemplate.get('type');
            if (routeTemplate.get('timeCorrection'))
                params.timecorrection = routeTemplate.get('timeCorrection');
        }
        return $.ajax({
            url: Core.contextRoot + '/routing/leg/route?' + $.param(params),
            type: 'POST',
            data: JSON.stringify([ fromDestination, toDestination ]),
            contentType: 'application/json',
            success: function(leg) {
                _(toDestination).extend(leg[1]);
                toDestination.routed = true;
            }
        });
    },

    removeDestination: function(destination) {
        var destinations = this.get('destinations');
        var index = destinations.indexOf(destination);
        if (index >= 0) {
            destinations.splice(index, 1);
            // Remove route data from next
            if (!this.get('routeId') && index < destinations.length) {
                var nextDestination = destinations[index];
                delete nextDestination.routeData;
                delete nextDestination.routeTime;
                delete nextDestination.routeDistance;
            }
        } else
            console.error('destination not found', destination, destinations);
    },

    shareByEmail: function(emailAddress, message, shareInternalInfo, pdf, include) {
        var data = { to: emailAddress, message: message };
        if (shareInternalInfo) data.internal = true;
        if (pdf) data.pdf = true;
        if (typeof include == 'object')
            data.include = include.join(',');
        else if (include)
            data.include = include;
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/share/email',
            type: 'POST',
            data: data
        }).success(function (data) {
                self.attributes.events.push({
                    type: 'SHARE',
                    comment: emailAddress,
                    userId: Core.client.me.get('id'),
                    eventTimeStamp: new Date().getTime(),
                    internal: true
                });
            });

    },

    fetchItems: function(options) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/items',
            type: 'GET',
        }).success(function (items) {
            self.set({items: items}, options)
        });
    },

    putItem: function(item) {
        if (! ('uuid' in item)) item.uuid = Core.randomUUID();
        var itemUuids = this.get('items').map(function(i) { return i.uuid }); // Use ids to avoid adding duplicates
        var duplicateIndex = itemUuids.indexOf(item.uuid);
        if (duplicateIndex < 0) this.get('items').push(item);
        else this.get('items').splice(duplicateIndex, 1, item); // Replace duplicate with currently edited one

        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/item/' + item.uuid,
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify(item)
        }).success(function (data) {
            // 2022-09-14 #15614: could cause price summary to not update when editing items
            //if (self.get('version')) self.set({version: self.get('version')+1}, {silent: true});
        });
    },

    deleteItem: function(item) {
        var index = this.get('items').indexOf(item);
        if (index >= 0)
            this.get('items').splice(index, 1);
            var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/item/' + item.uuid,
            type: 'DELETE'
        }).success(function (data) {
            // 2022-09-14 #15614: could cause price summary to not update when editing items
            //if (self.get('version')) self.set({version: self.get('version')+1}, {silent: true});
        });
    },

    resetPricing: function() {
        _(this.get('items')).each(function (item) { item.articleUnitPrice = item.articleUnitCost = null; })
    },

    fetchItemPrices: function(options) {
        var params = {};
        if (this.get('totalWeight')) params.weight = this.get('totalWeight');
        if (this.get('totalDistance')) params.distance = this.get('totalDistance');
        var self = this;
        return Core.client.fetchItemPrices(this.get('items'), this.get('customerId'), this.get('customerProjectId'), params).success(function(items) {
            self.set({items: items}, options)
        });
    },

    attachDocument: function(document) {
	    var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/document/' + document.get('uuid'),
            type: 'PUT'
        }).success(function() {
            if (self.get('version')) self.set({version: self.get('version')+1}, {silent: true});
            document.set('groupId', self.get('groupId'));
        });
    },

    detachDocument: function(documentId) {
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/document/' + documentId,
            type: 'DELETE'
        }).success(function() {
            if (self.get('version')) self.set({version: self.get('version')+1}, {silent: true});
            self.set({documents: _(self.get('documents')).filter(function(d) { return d.id != documentId && d.uuid != documentId })}, { silent: true });
            self.trigger('detachDocument', self);
        });
    },

    sendBroadcast: function(content) {
        var data = { content: content };
        var self = this;
        return $.ajax({
            url: this.urlRoot + '/' + this.id + '/broadcast',
            type: 'POST',
            data: data
        }).success(function (data) {
            if (self.get('version')) self.set({version: self.get('version')+1}, {silent: true});
            self.attributes.events.push({
                type: 'BROADCAST',
                userId: Core.client.me.get('id'),
                eventTimeStamp: new Date().getTime(),
                internal: true
            });
        });

    },

    allDestinationsValid: function() {
        if (!this.get('destinations') || this.get('destinations').length == 0) return false;
        var valid = true;
        _(this.get('destinations')).each(function (destination) {
            if (!destination.location || !destination.location.latitude || !destination.location.longitude) valid = false;
        });
        return valid;
    },

    clearRoute: function() {
        _(this.get('destinations')).each(function (destination) {
            delete destination.routeData;
            delete destination.routed;
            delete destination.routeTime;
            delete destination.routeDistance;
        });
    },

    clearDestinationRoute: function(destination) {
        if (typeof destination == 'number')
            destination = this.get('destinations')[destination];
        if (!destination) return;

        delete destination.routeData;
        delete destination.routed;
        delete destination.routeTime;
        delete destination.routeDistance;
        var index = this.get('destinations').indexOf(destination);
        if (index >= 0 && index < this.get('destinations').length-1) {
            var nextDestination = this.get('destinations')[index+1];
            delete nextDestination.routeData;
            delete nextDestination.routed;
            delete nextDestination.routeTime;
            delete nextDestination.routeDistance;
        }
    },

    getFirstArrivalTime: function() {
        var destinations = this.get('destinations');
        if (!destinations) return null;
        for (var i = 0; i < destinations.length; i++)
            if (destinations[i].arrivalTime) return destinations[i].arrivalTime;
        return null;
    },

    getFirstCalculatedArrivalTime: function() {
        var destinations = this.get('destinations');
        if (!destinations) return null;
        for (var i = 0; i < destinations.length; i++)
            if (destinations[i].calculatedArrivalTime) return destinations[i].calculatedArrivalTime;
        return null;
    },

    getTotalRouteTime: function() {
        var totalTime = 0;
        var destinations = this.get('destinations');
        if (!destinations) return null;
        for (var i = 1; i < destinations.length; i++) {
            var destination = destinations[i];
            if (typeof destination.routeTime != 'number') return null;
            totalTime += destination.routeTime;
        }
        return totalTime;
    },

    getTotalStopDuration: function() {
        var totalTime = 0;
        var destinations = this.get('destinations');
        if (!destinations) return null;
        for (var i = 0; i < destinations.length; i++) {
            var destination = destinations[i];
            totalTime += destination.stopDuration || 0;
        }
        return totalTime;
    },

    getTotalRouteDistance: function() {
        var totalDistance = 0;
        var destinations = this.get('destinations');
        if (!destinations) return null;
        for (var i = 1; i < destinations.length; i++) {
            var destination = destinations[i];
            if (typeof destination.routeDistance != 'number') return null;
            totalDistance += destination.routeDistance;
        }
        return totalDistance;
    },

    getStraightLineDistance: function() {
        var totalDistance = 0;
        var destinations = this.get('destinations');
        if (!destinations) return null;
        for (var i = 1; i < destinations.length; i++) {
            var destination = destinations[i];
            var previous = destinations[i-1];
            if (!destination.location || !destination.location.latitude || !destination.location.longitude) return null;
            if (!previous.location || !previous.location.latitude || !previous.location.longitude) return null;
            totalDistance += distanceSloc(destination.location.latitude, destination.location.longitude, previous.location.latitude, previous.location.longitude, GMEAN_EARTH_RADIUS_METERS);
        }
        return totalDistance;

    },

    getRouteDescription: function() {
        var destinations = this.get('destinations');
        if (destinations && destinations.length > 0) {
            var text;
            if (destinations.length == 1) {
                if (destinations[0].location)
                    text = destinations[0].location.placeName;
            } else {
                for (var i = 1; i < destinations.length; i++) {
                    var destination = destinations[i];
                    if (destination.location && destination.location.placeName) {
                        text = destination.location.placeName;
                        break;
                    }
                }
                if (destinations.length > 2 && text)
                    text += ' (+' + (destinations.length-2) + ')';
            }
            return text;
        }
    },

    getResourcesDescription: function(html) {
        var str = '';
        var resources = this.get('resources');
        if (typeof resources === 'undefined' || !resources)
            return '';
        _(resources).each(function (resource) {
            if (resource.userId) {
                if (str.length > 0) str += ', ';
                var name = resource.userId == Core.client.me.id ? i18next.t('me') : Formatting.shortName(resource);
                if (resource.state == 'ASSIGNED') {
                    str += html ? '<span class="muted">' + name + '</span>' : name;
                } else if (resource.state == 'DECLINED') {
                    str += html ? '<s>' + name + '</s>' : name;
                } else {
                    str += name;
                }
            } else if (resource.fullName && resource.fullName != '') {
                if (str.length > 0) str += ', ';
                var name = Formatting.shortName(resource);
                if (resource.state == 'ASSIGNED') {
                    str += html ? '<span class="muted">' + name + '</span>' : name;
                } else if (resource.state == 'DECLINED') {
                    str += html ? '<s>' + name + '</s>' : name;
                } else {
                    str += name;
                }
            }

            if (resource.assets && Core.client.assets) {
                _(resource.assets).each(function (assetResource) {
                    if (assetResource.assetName) {
                        if (str.length > 0) str += ', ';
                        str += assetResource.assetName;
                    } else if (assetResource.assetId) {
                        var asset = Core.client.assets.get(assetResource.assetId);
                        if (asset) {
                            var title = asset.get('name') || asset.get('assetNo');
                            if (title) {
                                if (str.length > 0) str += ', ';
                                str += title;
                            }
                        }
                    } else if (assetResource.assetTypeId) {
                        var assetType = Core.client.assetTypes.get(assetResource.assetTypeId);
                        if (assetType && assetType.get('name')) {
                            if (html) {
                                if (str.length > 0) str += '<span class="muted">, ' + assetType.get('name').toLowerCase() + '</span>';
                                else str += '<span class="muted">' + assetType.get('name') + '</span>';
                            } else {
                                if (str.length > 0) str += ', ' + assetType.get('name').toLowerCase();
                                else str += assetType.get('name');
                            }
                        }
                    }
                }, this);
            }

        }, this);
        return str;
    },

    myFollower: function() { return _(this.get('followers')).findWhere({userId: Core.client.me.id}); },
    myFollowerOptions: function() {
        var myOptions = [];
        if (!Core.client.groups || !this.get('groupId')) return null;
        var group = Core.client.groups.get(this.get('groupId'));
        if (!group) return null;
        var myFollower = this.myFollower();
        if (myFollower) {
            if (myFollower.options != null)
                return myFollower.options;
            else
                return ['states', 'discrepancies']; // Follower.DEFAULT_OPTIONS
        }
        var groupOptions = group.get('followerOptions');
        if (groupOptions['jobCreator'] && Core.client.me.id == this.get('creatorId')) {
            var options = groupOptions['jobCreator'];
            if (myOptions.length < options.length) myOptions = options;
        }
        if (groupOptions['jobResource'] && this.myResource()) {
            var options = groupOptions['jobResource'];
            if (myOptions.length < options.length) myOptions = options;
        }
        if (groupOptions['jobDispatcher'] && _(this.get('resources')).findWhere({dispatcherId: Core.client.me.id})) {
            var options = groupOptions['jobDispatcher'];
            if (myOptions.length < options.length) myOptions = options;
        }
        if (groupOptions['jobGroupDispatcher'] && _(this.get('resources')).findWhere({dispatcherId: Core.client.me.id})) {
            var options = groupOptions['jobGroupDispatcher'];
            if (myOptions.length < options.length) myOptions = options;
        }
        if (groupOptions['jobOrderer'] && Core.client.me.id == this.get('ordererId')) {
            var options = groupOptions['jobOrderer'];
            if (myOptions.length < options.length) myOptions = options;

        }
        if (groupOptions['jobGroupOrderAdmin'] && Core.client.hasGroupPermission(this.get('groupId'), 'admin_orders') && Core.client.hasPermission('create_orders')) {
            var options = groupOptions['jobGroupOrderAdmin'];
            if (myOptions.length < options.length) myOptions = options;
        }
        return _(myOptions).uniq();
    },

    sortTime: function() {
        if (this.get('startTime')) return this.get('startTime');
        var destinations = this.get('destinations');
        if (destinations) {
            for (var i = 0; i < destinations.length; i++) {
                if (destinations[i].arrivalTime) return destinations[i].arrivalTime;
            }
            for (var i = 0; i < destinations.length; i++) {
                if (destinations[i].calculatedArrivalTime) return destinations[i].calculatedArrivalTime;
            }
        }
        if (this.get('startedTimeStamp')) return this.get('startedTimeStamp');
        if (this.get('endTime')) return this.get('endTime');
        if (this.get('endedTimeStamp')) return this.get('endedTimeStamp');
        return null;
    },

    sortTimeIncludingCurrentAndUntimed: function() {
        var sortTime = this.sortTime();
        if (sortTime) return sortTime;
        var state = this.get('state');
        if (state == 'FINISHED' || state == 'CANCELED' || state == 'CLOSED') return 0;
        if (state == 'IN_TRANSIT' || state == 'ON_STATION' || state == 'STARTED' || state == 'PAUSED' || state == 'DAY_FINISHED') return new Date().getTime();
        return this.get('creationTimeStamp') * 10; // always top of the list but still sorted according to creation time
    },

    getAssetReservation: function (assetId) {
	    if (!this.get('resources')) return null;
        if (assetId && typeof assetId == 'object') assetId = assetId.id;
        for (var i = 0; i < this.get('resources').length; i++) {
            var resource = this.get('resources')[0];
            if (resource && resource.assets) {
                for (var j = 0; j < resource.assets.length; j++) {
                    var assetReservation = resource.assets[j];
                    if (assetReservation.assetId == assetId) return assetReservation;
                }
            }
        }
    },

    getAssetReservationByType: function (assetTypeId) {
        if (!this.get('resources')) return null;
        if (assetTypeId && typeof assetTypeId == 'object') assetTypeId = assetTypeId.id;
        for (var i = 0; i < this.get('resources').length; i++) {
            var resource = this.get('resources')[0];
            if (resource && resource.assets) {
                for (var j = 0; j < resource.assets.length; j++) {
                    var assetReservation = resource.assets[j];
                    if (assetReservation.assetTypeId == assetTypeId) return assetReservation;
                }
            }
        }
    },

    getEmptyAssetReservationByType: function (assetTypeId) {
        if (!this.get('resources')) return null;
        if (assetTypeId && typeof assetTypeId == 'object') assetTypeId = assetTypeId.id;
        for (var i = 0; i < this.get('resources').length; i++) {
            var resource = this.get('resources')[0];
            if (resource && resource.assets) {
                for (var j = 0; j < resource.assets.length; j++) {
                    var assetReservation = resource.assets[j];
                    if (assetReservation.assetTypeId == assetTypeId && !assetReservation.assetId) return assetReservation;
                }
            }
        }
    },

    sumAmountsByUnit: function(unit, includeAddOn, requireWorkHours) {
        var sum = 0;
        if (this.get('items') && this.get('items').length > 0) {
            _(this.get('items')).each(function (item) {
                if (!item) return;
                if (item.delivered === false) return;
                if (item.addOn && !includeAddOn) return;
                if (!item.workHours && requireWorkHours) return;
                if (!unit || (item.unit == unit && item.amount))
                    sum += item.amount;
            }, this);
        }
        return sum;
    },

    sumAmountsByArticle: function(articleId, includeAddOn, requireWorkHours) {
        var sum = 0;
        if (this.get('items') && this.get('items').length > 0) {
            _(this.get('items')).each(function (item) {
                if (!item) return;
                if (item.delivered === false) return;
                if (item.addOn && !includeAddOn) return;
                if (!item.workHours && requireWorkHours) return;
                if (!articleId || (item.articleId == articleId && item.amount))
                    sum += item.amount;
            }, this);
        }
        return sum;
    },

    hasAssetReservations: function() {
        if (!this.get('resources')) return null;
        for (var i = 0; i < this.get('resources').length; i++) {
            var resource = this.get('resources')[0];
            if (resource && resource.assets && resource.assets.length > 0) return true;
        }
        return false;
    },

    groupPrefix: function() { return Core.client.groups.get(this.get('groupId')) && Core.client.groups.get(this.get('groupId')).get('prefix') ? Core.client.groups.get(this.get('groupId')).get('prefix') : ""},

    hasReferenceValues: function() {
        var fields = this.get('customFields');
        if (!fields) return false;
        for (var i = 0; i < fields.length; i++) {
            if (fields[i].type == 'REFERENCE_VALUE') return true;
        }
        return false;
    },

    updateReferenceValues: function() {
        var fields = ['groupId', 'customerId', 'customerProjectId', 'projectId', 'orderId', 'assetId', 'customFields'];
        var data = {};
        var self = this;
        fields.forEach(function(field) { data[field] = self.get(field); });
        return $.ajax({
            url: Core.contextRoot + '/job/preview-reference-values',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function(values) {
                var changed = false;
                var fields = self.get('customFields');
                _(values).each(function (value, name) {
                    _(fields).each(function (field) {
                        if (field.name == name && field.value != value) {
                            field.value = value;
                            changed = true;
                        }
                    });
                });
                if (changed) self.set('customFields', fields);
            }
        });
    },

});

var Jobs = Backbone.Collection.extend({
    model: Job,
    jobsFilterKey: 'jobs.filterParams',

	url: function(options) {
        if (!options) options = {};
		if (this.customUrl) return this.customUrl;

		// Build query from filter parameters
		var url;
		var params = { };

        if (!options.lastModified) {
            if (this.filterParams.onlyInvoiced) params.onlyinvoiced = '';
            if (this.filterParams.states) {
                if (typeof this.filterParams.states == 'object')
                    params.states = this.filterParams.states.join(',');
                else
                    params.states = this.filterParams.states;
            } else {
                if (this.filterParams.includeFinished) params.finished = '';
                if (this.filterParams.includeCanceled) params.canceled = '';
                if (this.filterParams.includeDrafts) params.drafts = '';
                if (this.filterParams.includeClosed) params.closed = '';
            }
        }

        if (this.searchQuery) {
            url = Core.contextRoot + '/job/search';
            params.q = this.searchQuery;
        } else {
            url = Core.contextRoot + '/job/list' + (this.filterParams.path ? '/'+this.filterParams.path : '');
            if (this.filterParams.path == 'templates') {
                url = Core.contextRoot + '/job/templates';
                if (this.filterParams.includeDrafts) params.drafts = true;
                if (this.filterParams.onlyEditable) params.only_editable = true;
            } else {
                if (this.filterParams.path == 'user' && this.filterParams.userId) url += '/' + this.filterParams.userId;
                if (options.lastModified) {
                    params.states = 'ALL';
                    params.modified = options.lastModified;
                } else {
                    if (this.filterParams.includeUntimed) params.untimed = '';
                    if (this.filterParams.from == null || typeof this.filterParams.from == 'undefined') {
                        var fromDate = new Date();
                        fromDate.setHours(0,0,0,0);
                        this.filterParams.from = fromDate.getTime();
                    }
                    params.from = this.filterParams.from;
                    if (this.filterParams.to)
                        params.to = this.filterParams.to;
                    if ('includeCurrent' in this.filterParams) {
                        if (this.filterParams.includeCurrent)
                            params.current = '';
                    } else if (!this.filterParams.from && !this.filterParams.to)
                        params.current = '';
                }
            }
            if (this.filterParams.params) _(params).extend(this.filterParams.params);
        }
        if (this.filterParams.noCache) params.nocache = '';
        if (this.filterParams.limit) params.limit = this.filterParams.limit;
        if (this.filterParams.offset) params.offset = this.filterParams.offset;
        if (this.filterParams.includeItems) params.items = this.filterParams.includeItems;
        if (this.filterParams.groupIds) params.groups = this.filterParams.groupIds.join(',');
        if (this.filterParams.includeWorkedDates) params.includeworkeddates = '';

		var paramsStr = $.param(params);
		if (paramsStr.length > 0) url += '?' + paramsStr;
		return url;
	},

	initialize: function(models, options) {
		this.filterParams = {
			path: 'all',
            states: ['DRAFT','PUBLISHED','ASSIGNED','SCHEDULED','ACCEPTED','IN_TRANSIT','ON_STATION','STARTED','PAUSED','DAY_FINISHED','FINISHED','CANCELED'],
            includeAttested: true,
            includeCurrent: true,
            includeUntimed: true,
			from: null,
			to: null,
			userId: null
		};
        if (options && options.history)
            this.filterParams.states.push('CLOSED');
		if (options && options.url)
			this.customUrl = options.url;
		else if (options && options.filterParams)
			_(this.filterParams).extend(options.filterParams);
		else if ((!options || !options.temporary) && (this.jobsFilterKey in sessionStorage))
			this.filterParams = JSON.parse(sessionStorage[this.jobsFilterKey]);
		if (! 'path' in this.filterParams)
			this.filterParams.path = 'all';
	},

	saveFilter: function() {
        var storage = window.localStorage ? window.localStorage : window.sessionStorage;
        console.log('saveFilter: '+this.jobsFilterKey);
        this.filterParams.savedTimeStamp = new Date().getTime();
        storage[this.jobsFilterKey] = JSON.stringify(this.filterParams);
	},

    loadFilter: function(options) {
        var storage = window.localStorage ? window.localStorage : window.sessionStorage;
        var storedFilter = true;
        if (storage && storage[this.jobsFilterKey]){
            console.log('loadFilter: '+this.jobsFilterKey);
            var savedFilterParams = JSON.parse(storage[this.jobsFilterKey]);
            savedFilterParams.path = this.filterParams.path; //path may differ
            if (savedFilterParams.savedTimeStamp && savedFilterParams.savedTimeStamp < new Date().getTime()-8*60*60*1000){
                savedFilterParams.from = null;
                savedFilterParams.to = null;
                storedFilter = false;
            }
            this.filterParams = savedFilterParams;
        } else {
            console.log('Didnt loadFilter: '+this.jobsFilterKey);
            storedFilter = false;
        }
        if (Core.defaultJobListDateRange && !storedFilter) {
            var currentDate = new Date();
            currentDate.setHours(0,0,0,0);
            this.filterParams.from = currentDate.getTime();
            currentDate.addDays(Core.defaultJobListDateRange + 1);
            this.filterParams.to = currentDate.getTime();
            if (options && typeof options.to != 'undefined') this.filterParams.to = options.to;
        }
    },

    forEachRelevantTemplate: function(callback, context) {
        var limitToPrimaryGroup = Core.client.me.get('shareAllWithPrimaryGroup') && this.filter(function (template) {
                return template.isValidForGroup(Core.client.me.get('primaryGroupId')) && Core.client.hasPermissionInGroupOrDescendant(template.get('groupId'), 'create_jobs');
            }).length > 0;
        return this.each(function (template) {
            var defaultTemplate = Core.client.primaryGroup() && Core.client.primaryGroup().getOrGetInParentGroup('defaultJobTemplateId') == template.id;
            if (template.get('groupId') && !Core.client.hasPermissionInGroupOrDescendant(template.get('groupId'), 'create_jobs')) return;
            if (limitToPrimaryGroup && !template.isValidForGroup(Core.client.me.get('primaryGroupId'))) return;
            callback.apply(context, [template, defaultTemplate]);
        });
    },

});

Jobs.filterCollection = function(filter, collection) {
    var makeTimeSpanPredicate = function (from, to) {
        // Max date.getTime() allowed by Javascript.
        to = to || 8640000000000000;
        return function (job) {
            if (job.get('creationTimeStamp') && !job.get('startTime') && job.get('creationTimeStamp') >= from && job.get('creationTimeStamp') < to) return true;
            if (job.get('startTime') && job.get('startTime') >= from && job.get('startTime') < to) return true;
            if (job.get('endTime') && job.get('endTime') >= from && job.get('endTime') < to) return true;
            if (job.get('startTime') && job.get('endTime') && job.get('endTime') >= from && job.get('startTime') < to) return true;
            if (!job.get('startTime') && !job.get('endTime') && job.get('startedTimeStamp') && job.get('startedTimeStamp') >= from && job.get('startedTimeStamp') < to) return true;
            if (!job.get('startTime') && !job.get('endTime') && job.get('endedTimeStamp') && job.get('endedTimeStamp') >= from && job.get('endedTimeStamp') < to) return true;
        }
    };

    var filter = _(filter).clone();
    if (!filter.list) filter.list = 'all';
    var userId, vehicleId, assetTypeId, label, userResource, userOrderer, contractId;
    if (filter.list == 'mine') {
        userId = Core.client.me.id;
        userResource = userOrderer = true;
        delete filter.where;
    } else if (filter.list == 'mine-resource') {
        userId = Core.client.me.id;
        userResource = true;
        delete filter.where;
    } else if (filter.list == 'mine-orderer') {
        userId = Core.client.me.id;
        userOrderer = true;
        delete filter.where;
    } else if (filter.list.indexOf('user-') == 0) {
        userId = parseInt(filter.list.replace('user-', ''));
        userResource = userOrderer = true;
        delete filter.where;
    } else if (filter.list.indexOf('label-') == 0) {
        label = filter.list.replace('label-', '');
        delete filter.where;
    } else if (filter.list.indexOf('vehicle-') == 0) {
        vehicleId = parseInt(filter.list.replace('vehicle-', ''));
        delete filter.where;
    } else if (filter.list.indexOf('contract-') == 0) {
        contractId = parseInt(filter.list.replace('contract-', ''));
        delete filter.where;
    } else if (filter.list.indexOf('activity-') == 0) {
        filter.where = { activityId: parseInt(filter.list.replace('activity-','')) };
    } else if (filter.list.indexOf('group-') == 0) {
        filter.where = { groupId: parseInt(filter.list.replace('group-','')) };
    } else if (filter.list.indexOf('customer-') == 0) {
        filter.where = { customerId: parseInt(filter.list.replace('customer-', '')) };
    } else if (filter.list.indexOf('asset-') == 0) {
        filter.where = {assetId: parseInt(filter.list.replace('asset-', ''))};
    } else if (filter.list.indexOf('assettype-') == 0) {
        assetTypeId = parseInt(filter.list.replace('assettype-', ''));
        delete filter.where;
    } else if (filter.list == 'not-in-route') {
        filter.where = {routeId: null};
    } else if (filter.list == 'all' || filter.list == 'unassigned' || filter.list == 'today' || filter.list == 'in-route' || filter.list == 'late' || filter.list == 'ongoing' || filter.list == 'scheduled') {
        delete filter.where;
    } else {
        console.error('Unknown filter selection ' + filter.list);
    }
    if (typeof filter.includeCurrent !== 'undefined') collection.filterParams.includeCurrent = filter.includeCurrent;
    if (typeof filter.includeUntimed !== 'undefined') collection.filterParams.includeUntimed = filter.includeUntimed;
    if (typeof filter.includeAttested !== 'undefined') collection.filterParams.includeAttested = filter.includeAttested;

    var filteredCollection = new Jobs(filter.where ? collection.where(filter.where) : collection.models);
    if (userId) {
        filteredCollection.reset(filteredCollection.filter(function (job) {
            if (userOrderer) {
                var ordererId = job.get('ordererId');
                if (ordererId) {
                    if (ordererId == userId) return true;
                }
                ordererId = job.get('orderOrdererId')
                if (ordererId) {
                    if (ordererId == userId) return true;
                }
                /* #21703
                ordererId = job.get('creatorId')
                if (ordererId) {
                    if (ordererId == userId && !job.get('ordererId') && !job.get('orderOrdererId')) return true;
                }
                */
            }
            if (userResource) {
                var resource = job.getResource(userId);
                if (!resource) return false;
                // filter resource states
                if (resource.state == 'DECLINED') return false;
                if ((resource.state == 'ACCEPTED' || resource.state == 'INACTIVE')) {
                    if (collection.filterParams.states.indexOf('SCHEDULED') < 0)
                        return false;
                } else if (collection.filterParams.states.indexOf(resource.state) < 0)
                    return false;
                return true;
            }
        }, this), {silent: true});
    } else if (vehicleId) {
        filteredCollection.reset(filteredCollection.filter(function (job) {
            return job.getResourceByVehicle(vehicleId);
        }, this), {silent: true})
    } else if (assetTypeId) {
        filteredCollection.reset(filteredCollection.filter(function (job) {
            var asset = Core.client.assets.get(job.get('assetId'));
            return asset && asset.get('assetTypeId') == assetTypeId;
        }, this), {silent: true})
    } else if (contractId) {
        filteredCollection.reset(filteredCollection.filter(function (job) {
            var resource = job.getResource(contractId);
            if (!resource) return false;
            if (resource.state == 'DECLINED') return false;
            if ((resource.state == 'ACCEPTED' || resource.state == 'INACTIVE')) {
                if (collection.filterParams.states.indexOf('SCHEDULED') < 0)
                    return false;
            } else if (collection.filterParams.states.indexOf(resource.state) < 0)
                return false;
            return true;
        }, this), {silent: true});
    } else if (label) {
        filteredCollection.reset(filteredCollection.filter(function (order) {
            return order.get('labels') && order.get('labels').indexOf(label) >= 0;
        }, this), { silent: true })
    } else if (filter.list == 'unassigned') {
        filteredCollection.reset(filteredCollection.filter(function (job) {
            if (job.get('state') == 'FINISHED' || job.get('state') == 'CANCELED' || job.get('state') == 'CLOSED') return false;
            if (job.get('routeId')) return false;
            var schedulable = (!job.get('groupId') && job.get('creatorId') == Core.client.me.id) || Core.client.hasGroupPermission(job.get('groupId'), 'dispatch');
            if (schedulable) {
                var resources = job.get('resources');
                if (!resources || resources.length == 0) return true;
                var scheduled = true;
                _(resources).each(function (resource) {
                    if (!job.isResourceScheduled(resource)) scheduled = false;
                }, this);
                return !scheduled;
            } else {
                return job.get('selfScheduled') && job.get('state') == 'PUBLISHED';
            }
        }, this), { silent: true });
    } else if (filter.list == 'today') {
        filteredCollection.reset(filteredCollection.filter(makeTimeSpanPredicate(Date.today().getTime(), Date.today().addDays(1).getTime()), this), { silent: true });
    } else if (filter.list == 'in-route') {
        filteredCollection.reset(filteredCollection.filter(function (job) { return job.get('routeId'); }), { silent: true });
    } else if (filter.list == 'late') {
        filteredCollection.reset(filteredCollection.filter(function (job) { return job.isLate(); }), { silent: true });
    } else if (filter.list == 'ongoing') {
        filteredCollection.reset(filteredCollection.filter(function (job) { return ['IN_TRANSIT', 'ON_STATION', 'STARTED', 'PAUSED', 'DAY_FINISHED'].indexOf(job.get('state')) >= 0; }), { silent: true });
    }
    // filter out deletes and state changes from updates
    filteredCollection.reset(filteredCollection.filter(function (job) {
        if (!collection.filterParams.includeAttested && job.get("attestedTimeStamp") != null) return false;
        if (collection.filterParams && collection.filterParams.states && collection.filterParams.states.indexOf(job.get('state')) < 0) return false;
        return !job.get('deleted');
    }), { silent: true });
    if (collection.filterParams && collection.filterParams.activities && Core.client.activities && Core.client.activities.length > 0)
        filteredCollection.reset(filteredCollection.filter(function (job) {
            const activityId = job.get('activityId');
            const activity = Core.client.activities.get(activityId);
            const filterIndex = collection.filterParams.activities.indexOf(activityId);
            //check for and include non existing/deleted activity as part of (ingen)
            if (collection.filterParams.activities.indexOf(null) >= 0 && !activity && activityId) return true 
            else if ((activityId === null || activity || (activityId && !activity)) && filterIndex < 0) return false;
            return true;
        }), {silent: true});
    if (collection.filterParams && collection.filterParams.labels && Core.client.labels && Core.client.labels.length > 0)
        filteredCollection.reset(filteredCollection.filter(function(job) {
            if (collection.filterParams.labels.indexOf(null) >= 0 &&
                    (
                    job.get('labels') === null ||
                    job.get('labels').length <= 0 ||
                    !job.get('labels').find(function(label) {
                        return Core.client.labels.find(function(coreLabel){return coreLabel.get('label') == label}); //Include removed label in None filter
                    })
                    )
                )
                return true;
            return job.get('labels').find(function(label) {
                return collection.filterParams.labels.indexOf(label) >= 0;
            });
        }), {silent: true});
    if (collection.filterParams && collection.filterParams.bookingRequests){
        filteredCollection.reset(filteredCollection.filter(function(job) {
            var group = Core.client.groups.get(job.get('groupId'));
            const activityId = job.get('activityId');
            var includeNullBookingRequests = collection.filterParams.bookingRequests.indexOf(null) >= 0;
            if(!job.get('bookingRequests') && group && group.get('configuration') && group.get('configuration')["enable_booking_request_sms"] && !includeNullBookingRequests){
                var activities = group.get('textmessageFollowerOptions')['bookingRequestActivities'];
                if (activities != null && activities.length != 0 && activityId != null){
                    return activities.includes(activityId.toString()) && collection.filterParams.bookingRequests.indexOf(i18next.t('booking_request_waiting')) >= 0;
                }
            }
            if(!job.get('bookingRequests')) {
                return includeNullBookingRequests;
            }
            if(job.get('bookingRequests') && job.get('bookingRequests')[job.get('bookingRequests').length-1]){
                return collection.filterParams.bookingRequests.indexOf(i18next.t(job.get('bookingRequests')[job.get('bookingRequests').length-1].status.toLowerCase())) >= 0;
            }
            else {
                return includeNullBookingRequests;
            }
        }), {silent: true});
    }
    var beastEnabled = false;
    Core.client.me.get('groupMemberships').forEach(function(group) {
        if (group.active && Core.client.hasGroupPermission(group.groupId, 'view_beast')) beastEnabled = true;
    });
    if (beastEnabled && collection.filterParams && collection.filterParams.beastStates) {
        var beastStatesSet = new Set(collection.filterParams.beastStates);
        if (beastStatesSet.has('ACCEPTED')) {
            beastStatesSet.add('CONDITIONALLY_ACCEPTED');
            beastStatesSet.add('FINISHED');
            beastStatesSet.add('CLOSED');
        }
        filteredCollection.reset(filteredCollection.filter(function(job) {
            var docs = job.get('beastDocuments');
            if (!docs || docs.length == 0) return beastStatesSet.has(null);
            return docs.some(function(doc) { return doc && doc.state && beastStatesSet.has(doc.state); });
        }), { silent: true });
    }
    if (filter.timeSpan) {
        filteredCollection.reset(filteredCollection.filter(makeTimeSpanPredicate(filter.timeSpan.from, filter.timeSpan.to), this), { silent: true });
    }
    if (filter.filterParams && filter.filterParams.states && filter.filterParams.states.length > 0) {
        var statesSet = new Set(filter.filterParams.states);
        filteredCollection.reset(filteredCollection.filter(function(job) {
            return statesSet.has(job.get('state'));
        }, this), { silent: true });
    }
    filteredCollection.filterParams = JSON.parse(JSON.stringify(collection.filterParams));
    return filteredCollection;
};
